import { useInfiniteQuery } from '@tanstack/react-query';
import { concat, isEmpty } from 'lodash';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapLocationsWithHQ } from './helper';

export const useGetPublicationList = (filters: string[] = []) => {
  return useInfiniteQuery(
    queryKeys.enrichedLocations.pagination(filters),
    ({ pageParam = 1 }) => fetchPaginatedPublicationList(pageParam, filters),
    {
      enabled: !isEmpty(filters),
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = lastPage ? allPages.length : 1;
        const totalPages = lastPage ? lastPage?.totalPages : 1;

        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
};

const fetchPaginatedPublicationList = async (
  page: number,
  filters: string[],
) => {
  const response = await requestCCApi({
    url: `/enrichedLocations${generateQuery(
      [],
      concat(filters, [`count=true`, `page=${page}`]),
    )}`,
  });

  return mapLocationsWithHQ(response);
};
